<template>
  <div>
    <v-dialog v-model="product_dialog" width="500" persistent>
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="250"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold"
            >Edit Product</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon color="grey" dark @click="cancel_product_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="ma-5 overflow-y-auto"
          style="text-align: left; max-height: 550px"
        >
          <v-form ref="form">
            <div>
              <p style="font-weight: bold">Product Name:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_product_name"
                  single-line
                  outlined
                  dense
                  :rules="[
                    () => !!selected_product_name || 'Product name is required',
                    () =>
                      selected_product_name.length >= 5 ||
                      'At least 5 characters',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Product Description:</p>
              <div style="margin-top: -10px">
                <v-textarea
                  v-model="selected_product_description"
                  single-line
                  outlined
                  dense
                  :rules="[
                    () =>
                      !!selected_product_description ||
                      'Product description is required',
                    () =>
                      selected_product_description.length >= 5 ||
                      'At least 5 characters',
                  ]"
                ></v-textarea>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Product Category:</p>
              <div style="margin-top: -10px">
                <v-combobox
                  v-model="selected_product_category"
                  :items="product_category_list"
                  single-line
                  outlined
                  multiple
                  dense
                  :rules="[
                    () =>
                      selected_product_category.length > 0 ||
                      'At least one product category is needed',
                  ]"
                ></v-combobox>
              </div>
            </div>
          </v-form>
        </div>
        <v-card-actions v-if="selected_product_status != 'rejected'">
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            color="primary"
            class="white--text"
            block
            depressed
            style="text-transform: capitalize"
            @click="update_product"
            :loading="is_submitting"
            :disabled="is_submitting"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Ecom Product Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="product_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          item-key="product_id"
          :show-select="true"
          v-model="selected_product_list"
          @click:row="view_product"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Products"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                color="blue"
                dark
                style="text-transform: capitalize"
                class="mr-5"
                @click="delete_products"
                v-if="selected_product_list.length > 0"
              >
                <v-icon left dark> mdi-close </v-icon>
                Delete
              </v-btn>
              <v-btn
                depressed
                color="primary"
                dark
                style="text-transform: capitalize"
                @click="create_product"
              >
                <v-icon left dark> mdi-plus </v-icon>
                Create Product
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.cover_image`]="props">
            <div v-if="props.item.cover_image != ''">
              <img
                width="60"
                height="60"
                :src="props.item.cover_image"
                alt="image"
              />
            </div>
            <div v-else>
              <p style="margin-bottom: 0">No Image</p>
            </div>
          </template>
          <template v-slot:[`item.status`]="props">
            <v-chip :color="getStatusColor(props.item.status)" dark label>
              {{ props.item.status }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        {
          text: "Product Name",
          value: "product_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Cover Image",
          value: "cover_image",
          sortable: true,
          divider: true,
          align: "center",
          width: 150,
        },
        {
          text: "Shop Name",
          value: "shop_name",
          sortable: true,
          divider: true,
        },
        { text: "Price (RM)", value: "price", sortable: true, divider: true },
        {
          text: "Status",
          value: "status",
          sortable: true,
          divider: true,
          align: "center",
          width: 120,
        },
        {
          text: "Product Category",
          value: "product_category",
          sortable: true,
          divider: true,
        },
      ],
      product_list: [],
      table_loading: false,
      search: "",
      selected_product_list: [],
      product_dialog: false,
      selected_product_id: "",
      selected_product_name: "",
      selected_product_description: "",
      selected_product_status: "",
      selected_product_category: [],
      product_category_list: [],
      is_submitting: false,
    };
  },
  methods: {
    create_product() {
      this.$router
        .push({ name: "ProductDetailScreen", params: { id: "create" } })
        .catch((err) => {});
    },
    async update_product() {
      if (this.$refs.form.validate()) {
        this.is_submitting = true;
        var response = await this.send_http_request("updateProduct", {
          product_id: this.selected_product_id,
          product_name: this.selected_product_name,
          product_description: this.selected_product_description,
          product_category: this.selected_product_category,
        });
        this.is_submitting = false;
        if (response.data.status == "OK") {
          this.cancel_product_dialog();
          this.load_product();
          this.show_snack_bar("success", "Product Updated");
        } else {
          this.show_snack_bar("error", "Something went wrong");
        }
      }
    },
    view_product(value) {
      this.selected_product_id = value.product_id;
      this.selected_product_name = value.product_name;
      this.selected_product_category = value.product_category;
      this.selected_product_status = value.status;
      this.selected_product_description = value.product_description.replace(
        /\\n/g,
        "\n"
      );
      this.product_dialog = true;
    },
    load_product() {
      this.table_loading = true;
      this.send_http_request("getAllEcomProducts", {})
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.product_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    load_product_category() {
      this.send_http_request("loadAllProductCategory", {})
        .then((response) => {
          if (response.data.status == "OK") {
            this.product_category_list = response.data.result;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async delete_products() {
      var product_list = [];
      this.selected_product_list.forEach((product) => {
        product_list.push(product.product_id);
      });
      this.show_close_loading("show", "Removing");
      var response = await this.send_http_request("deleteProducts", {
        product_list: product_list,
      });
      this.show_close_loading("close");
      if (response.data.status == "OK") {
        this.selected_product_list = [];
        this.show_snack_bar("success", "Products Removed");
        this.load_product();
      } else {
        this.show_snack_bar("error", "Something went wrong");
      }
    },
    cancel_product_dialog() {
      this.selected_product_id = "";
      this.selected_product_name = "";
      this.selected_product_description = "";
      this.selected_product_status = "";
      this.selected_product_category = [];
      this.product_dialog = false;
      this.$refs.form.resetValidation();
    },
    getStatusColor(status) {
      if (status == "rejected") {
        return "red";
      } else if (status == "archived") {
        return "grey";
      } else if (status == "approved") {
        return "green";
      } else if (status == "draft") {
        return "teal";
      } else {
        return "grey";
      }
    },
  },
  mounted() {
    this.load_product();
    this.load_product_category();
  },
  created() {
    // Update store
    var payload = { headerType: "needHeader", currentPage: "ProductScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>